export const BODY_TYPES_IDS = {
  OFFROAD_CROSS: '1',
  ROAD_CUSTOM: '2',
  OFFROAD_ENDURO: '3',
  OFFROAD_KIDS: '4',
  ROAD_SPORT: '5',
  ROAD_SUPERMOTARD: '6',
  OFFROAD_TRAIL: '7',
  OFFROAD_TRIAL: '8',
  ROAD_TOURISM: '9',
  SCOOTER_125: '10',
  SCOOTER_125PLUS: '11',
  MOPED_2: '12',
  ROAD_NAKED: '14',
  MOPED_GEARS: '15',
  SCOOTER_50: '16',
  MOPED: '3010',
  SCOOTER: '3020',
  ROAD: '3030',
  OFFROAD: '3040'
}

export const BODY_TYPES = {
  [BODY_TYPES_IDS.OFFROAD_CROSS]: {
    id: BODY_TYPES_IDS.OFFROAD_CROSS,
    name: 'BODY_TYPE_OFFROAD_CROSS'
  },
  [BODY_TYPES_IDS.ROAD_CUSTOM]: {
    id: BODY_TYPES_IDS.ROAD_CUSTOM,
    name: 'BODY_TYPE_ROAD_CUSTOM'
  },
  [BODY_TYPES_IDS.OFFROAD_ENDURO]: {
    id: BODY_TYPES_IDS.OFFROAD_ENDURO,
    name: 'BODY_TYPE_OFFROAD_ENDURO'
  },
  [BODY_TYPES_IDS.OFFROAD_KIDS]: {
    id: BODY_TYPES_IDS.OFFROAD_KIDS,
    name: 'BODY_TYPE_OFFROAD_KIDS'
  },
  [BODY_TYPES_IDS.ROAD_SPORT]: {
    id: BODY_TYPES_IDS.ROAD_SPORT,
    name: 'BODY_TYPE_ROAD_SPORT'
  },
  [BODY_TYPES_IDS.ROAD_SUPERMOTARD]: {
    id: BODY_TYPES_IDS.ROAD_SUPERMOTARD,
    name: 'BODY_TYPE_ROAD_SUPERMOTARD'
  },
  [BODY_TYPES_IDS.OFFROAD_TRAIL]: {
    id: BODY_TYPES_IDS.OFFROAD_TRAIL,
    name: 'BODY_TYPE_OFFROAD_TRAIL'
  },
  [BODY_TYPES_IDS.OFFROAD_TRIAL]: {
    id: BODY_TYPES_IDS.OFFROAD_TRIAL,
    name: 'BODY_TYPE_OFFROAD_TRIAL'
  },
  [BODY_TYPES_IDS.ROAD_TOURISM]: {
    id: BODY_TYPES_IDS.ROAD_TOURISM,
    name: 'BODY_TYPE_ROAD_TOURISM'
  },
  [BODY_TYPES_IDS.SCOOTER_125]: {
    id: BODY_TYPES_IDS.SCOOTER_125,
    name: 'BODY_TYPE_SCOOTER_125'
  },
  [BODY_TYPES_IDS.SCOOTER_125PLUS]: {
    id: BODY_TYPES_IDS.SCOOTER_125PLUS,
    name: 'BODY_TYPE_SCOOTER_125PLUS'
  },
  [BODY_TYPES_IDS.MOPED_2]: {
    id: BODY_TYPES_IDS.MOPED_2,
    name: 'BODY_TYPE_MOPED_2'
  },
  [BODY_TYPES_IDS.ROAD_NAKED]: {
    id: BODY_TYPES_IDS.ROAD_NAKED,
    name: 'BODY_TYPE_ROAD_NAKED'
  },
  [BODY_TYPES_IDS.MOPED_GEARS]: {
    id: BODY_TYPES_IDS.MOPED_GEARS,
    name: 'BODY_TYPE_MOPED_GEARS'
  },
  [BODY_TYPES_IDS.SCOOTER_50]: {
    id: BODY_TYPES_IDS.SCOOTER_50,
    name: 'BODY_TYPE_SCOOTER_50'
  },
  [BODY_TYPES_IDS.MOPED]: {
    id: BODY_TYPES_IDS.MOPED,
    name: 'BODY_TYPE_MOPED'
  },
  [BODY_TYPES_IDS.SCOOTER]: {
    id: BODY_TYPES_IDS.SCOOTER,
    name: 'BODY_TYPE_SCOOTER'
  },
  [BODY_TYPES_IDS.ROAD]: {
    id: BODY_TYPES_IDS.ROAD,
    name: 'BODY_TYPE_ROAD'
  },
  [BODY_TYPES_IDS.OFFROAD]: {
    id: BODY_TYPES_IDS.OFFROAD,
    name: 'BODY_TYPE_OFFROAD'
  }
}
